<template>
    <div class="fullHeight">
        <MypageSideMenu @set="initialize" :memberDropClose="false"/>
        <Card
            :page_title="page_title"
            iconclass="icon-icon-info mypage-title-icon"
            >
            <div class="col-sm-12">
                <div class="err_msg" v-if="api_error">
                    <p>
                        <span class="text-danger">{{ this.err_msg_txt}}</span>
                    </p>
                </div>
                <div class="form-group row">
                    <div class="col-sm-3 col-form-label">会員番号</div>
                    <div class="col-sm-9 col-form-label text-right text-sm-left">{{ user_data.member_no }}</div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-3 col-form-label">氏名</div>
                    <div class="col-sm-9 col-form-label text-right text-sm-left">{{ user_data.full_name }}</div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-3 col-form-label">性別</div>
                    <div class="col-sm-9 col-form-label text-right text-sm-left">{{ user_data.gender }}</div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-3 col-form-label">生年月日</div>
                    <div class="col-sm-9 col-form-label text-right text-sm-left">{{ user_data.birth_date | replace('-','/') }}</div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-3 col-form-label">
                        <span class="pr-2">メールアドレス</span>
                        <span class="badge bg-danger text-white badge-required">※必須</span>
                    </div>
                    <div class="col-sm-9 col-form-label">
                        <input
                            id="mail"
                            type="text"
                            :class="{'is-invalid': valid.mail}"
                            class="form-control"
                            v-model="mail"
                            placeholder="半角英数字で入力"
                            @blur="checkInputData"
                            @input="checkInputData"
                        />
                        <div
                            class="invalid-feedback"
                            v-if="valid.mail"
                        >{{ valid_message.mail }}</div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-3 col-form-label">
                        <span class="pr-2">メールアドレス<br class="mail-confirm-br">（確認）</span>
                        <span class="badge bg-danger text-white badge-required">※必須</span>
                    </div>
                    <div class="col-sm-9">
                        <input
                            id="reMail"
                            type="text"
                            :class="{'is-invalid': valid.reMail}"
                            class="form-control"
                            v-model="reMail"
                            placeholder="半角英数字で入力"
                            @blur="checkInputData"
                            @input="checkInputData"
                        />
                        <div
                            class="invalid-feedback"
                            v-if="valid.reMail"
                        >{{ valid_message.reMail }}</div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-3 col-form-label">携帯番号</div>
                    <div class="col-sm-9 col-form-label text-right text-sm-left">{{ formatSP(user_data.mobile_number) }}</div>
                </div>
                <div class="mb-3">
                    <div class="row justify-content-center flex-column flex-sm-row px-3">
                        <button
                            type="button"
                            class="bluebackbutton mb-2 col-md-btn-size"
                            v-on:click="NextPage"
                            :disabled="submit_disabled"
                        >会員情報を変更</button>
                        <button
                            type="button"
                            class="mypagebackbutton mb-2 ml-0 ml-sm-5 col-md-btn-size"
                            @click="gotoMypageInfo"
                            >戻る
                        </button>
                    </div>
                </div>
            </div>
        </Card>
        <MypageMenuFooter/>
    </div>
</template>

<script>
import MypageSideMenu from "./MypageSideMenu";
import MypageHeader from './MypageHeader';
import validater from "../../lib/validater";
import Card from '../components/Card';
import { GET_MEMBER_ID } from "../../constants/signin";
import { GET_MEMBER, CHANGE_EMAIL_TMP } from "../../constants/mypage_info";
import { memberStatusMixin } from './memberStatusMixin';
import MypageMenuFooter from './MypageMenuFooter';

export default {
    components: {
        MypageSideMenu,
        MypageMenuFooter,
        MypageHeader,
        validater,
        Card
    },
    mixins: [memberStatusMixin],
    data() {
        return {
            // 変更不可能なユーザデータ
            user_data: {
                // 会員番号
                member_no: "",
                // 氏名
                full_name: "",
                // 性別
                gender: "",
                // 生年月日
                birth_date: "",
                // 携帯番号
                mobile_number: ""
            },
            page_title: '会員情報変更',
            submit_disabled: true,
            valid: {
                mail: false,
                reMail: false
            },
            valid_message: {
                mail: "",
                reMail: ""
            },
            api_error: false,
            mail: "",
            reMail: "",
            err_msg_txt: ""
        };
    },
    created() {
        this.initialize();
    },
    computed: {
        validation() {
            return {
                mail: function() {
                    return false;
                }
            };
        }
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize: function() {
            this.GetLoginUserMemberStatus();
            this.setMember();
        },
        /** --------------------------------------------
         * 会員情報を取得
         * -------------------------------------------- */
        setMember: function(member_no) {
            this.user_data.member_no = this.$store.state.auth.loginMember.member_no;
            this.user_data.full_name = this.$store.state.auth.loginMember.family_name
                                            + ' ' +
                                        this.$store.state.auth.loginMember.given_name;
            if (this.$store.state.auth.loginMember.gender === 0) {
                this.user_data.gender = "男性";
            } else if (this.$store.state.auth.loginMember.gender === 1) {
                this.user_data.gender = "女性";
            }
            this.user_data.birth_date = this.$store.state.auth.loginMember.birth_date;
            this.user_data.mobile_number = this.$store.state.auth.loginMember.mobile_number;
        },
        /** --------------------------------------------
         * 会員情報変更メールを送信
         * -------------------------------------------- */
        changeEmailTmp: function(email, email_confirmation) {
            this.$store.commit("loading/setIsLoading", true);
            this.$apollo
                .mutate({
                    mutation: CHANGE_EMAIL_TMP,
                    variables: {
                        email: email,
                        email_confirmation: email_confirmation
                    }
                })
                .then(res => {
                    this.$router.push({
                        path: "/mypage-member-setting-send-mail"
                    });
                })
                .catch(error => {
                    this.err_msg_txt =
                        error.graphQLErrors[0].extensions.validation.email[0];
                    this.api_error = true;
                    this.$store.commit("loading/setIsLoading", false);
                });
        },
        /** ----------------------------------------------
         * バリデーションチェック
         * ---------------------------------------------- */
        checkInputData: function(event) {
            if (event.type == "click") {
                if (!this.mail) {
                    this.valid_message.mail = this.$t(
                        "error.validation.required.mail"
                    );
                    this.valid.mail = true;
                }
                if (!this.reMail) {
                    this.valid_message.reMail = this.$t(
                        "error.validation.required.reMail"
                    );
                    this.valid.reMail = true;
                }
                // エラー状況をチェック
                if (!this.valid.mail && !this.valid.reMail) {
                    return true;
                }
                return false;
            } else if (event.type === "blur"){
                if (!event.target.value) {
                    if (event.target.id === "mail") {
                        this.valid_message.mail = this.$t(
                            "error.validation.required.mail"
                        );
                        this.valid.mail = true;
                    } else if (event.target.id === "reMail") {
                        this.valid_message.reMail = this.$t(
                            "error.validation.required.reMail"
                        );
                        this.valid.reMail = true;
                    }
                } else {
                    if (event.target.id === "mail") {
                        // メールアドレスチェック
                        if (
                            !validater.checkStringLengthMax(
                                event.target.value,
                                256
                            )
                        ) {
                            this.valid_message.mail = this.$t(
                                "error.validation.length.mail"
                            );
                            this.valid.mail = true;
                        } else if (!validater.checkMail(this.mail)) {
                            this.valid_message.mail = this.$t(
                                "error.validation.mailFormat"
                            );
                            this.valid.mail = true;
                        } else {
                            // メールアドレス一致チェック
                            if (this.mail && this.reMail) {
                                if (this.mail !== this.reMail) {
                                    this.valid_message.mail = this.$t(
                                        "error.validation.unmatch"
                                    );
                                    this.valid.mail = true;
                                } else {
                                    this.valid_message.mail = "";
                                    this.valid.mail = false;
                                    this.valid_message.reMail = "";
                                    this.valid.reMail = false;
                                }
                            } else {
                                this.valid_message.mail = "";
                                this.valid.mail = false;
                            }
                        }
                    } else if (event.target.id === "reMail") {
                        // メールアドレス（確認）チェック
                        if (
                            !validater.checkStringLengthMax(
                                event.target.value,
                                256
                            )
                        ) {
                            this.valid_message.reMail = this.$t(
                                "error.validation.length.reMail"
                            );
                            this.valid.reMail = true;
                        } else if (!validater.checkMail(this.reMail)) {
                            this.valid_message.reMail = this.$t(
                                "error.validation.mailFormat"
                            );
                            this.valid.reMail = true;
                        } else {
                            // メールアドレス一致チェック
                            if (this.mail && this.reMail) {
                                if (this.mail !== this.reMail) {
                                    this.valid_message.reMail = this.$t(
                                        "error.validation.unmatch"
                                    );
                                    this.valid.reMail = true;
                                } else {
                                    this.valid_message.mail = "";
                                    this.valid.mail = false;
                                    this.valid_message.reMail = "";
                                    this.valid.reMail = false;
                                }
                            } else {
                                this.valid_message.mail = "";
                                this.valid.mail = false;
                            }
                        }
                    }
                }
                this.disabledCheck();
            } else {
                if (event.target.value) {
                    if (event.target.id === "mail") {
                        // メールアドレスチェック
                        if (
                            !validater.checkStringLengthMax(
                                event.target.value,
                                256
                            )
                        ) {
                            this.valid_message.mail = this.$t(
                                "error.validation.length.mail"
                            );
                            this.valid.mail = true;
                        } else if (!validater.checkMail(this.mail)) {
                            this.valid_message.mail = this.$t(
                                "error.validation.mailFormat"
                            );
                            this.valid.mail = true;
                        } else {
                            // メールアドレス一致チェック
                            if (this.mail && this.reMail) {
                                if (this.mail !== this.reMail) {
                                    this.valid_message.mail = this.$t(
                                        "error.validation.unmatch"
                                    );
                                    this.valid.mail = true;
                                } else {
                                    this.valid_message.mail = "";
                                    this.valid.mail = false;
                                    this.valid_message.reMail = "";
                                    this.valid.reMail = false;
                                }
                            } else {
                                this.valid_message.mail = "";
                                this.valid.mail = false;
                            }
                        }
                    } else if (event.target.id === "reMail") {
                        // メールアドレス（確認）チェック
                        if (
                            !validater.checkStringLengthMax(
                                event.target.value,
                                256
                            )
                        ) {
                            this.valid_message.reMail = this.$t(
                                "error.validation.length.reMail"
                            );
                            this.valid.reMail = true;
                        } else if (!validater.checkMail(this.reMail)) {
                            this.valid_message.reMail = this.$t(
                                "error.validation.mailFormat"
                            );
                            this.valid.reMail = true;
                        } else {
                            // メールアドレス一致チェック
                            if (this.mail && this.reMail) {
                                if (this.mail !== this.reMail) {
                                    this.valid_message.reMail = this.$t(
                                        "error.validation.unmatch"
                                    );
                                    this.valid.reMail = true;
                                } else {
                                    this.valid_message.mail = "";
                                    this.valid.mail = false;
                                    this.valid_message.reMail = "";
                                    this.valid.reMail = false;
                                }
                            } else {
                                this.valid_message.mail = "";
                                this.valid.mail = false;
                            }
                        }
                    }
                }
                this.disabledCheck();
            }
        },
        /** ----------------------------------------------
         * 会員情報を変更ボタン制御処理
         * ---------------------------------------------- */
        disabledCheck: function() {
            if (
                this.mail !== "" &&
                this.reMail !== "" && // 全フォームに値があり
                this.valid.mail === false &&
                this.valid.reMail === false // バリデーションに問題ない場合のみ
            ) {
                this.submit_disabled = false; // ボタン押下可能
            } else {
                this.submit_disabled = true;
            }
        },
        /** ----------------------------------------------
         * 会員情報を変更ボタン処理
         * ---------------------------------------------- */
        NextPage: function(event) {
            this.api_error = false;
            if (this.checkInputData(event)) {
                // 登録内容画面へ遷移
                this.changeEmailTmp(this.mail, this.reMail);
            }
        },
        formatSP(number){
            if (number != null){
                if (number.length == 11) {
                    return number.substr(0,3) + "-" + number.substr(3,4) + "-" + number.substr(7,4);
                }
            }
            return number
        },
        /** ----------------------------------------------
         * 戻るボタンの処理 会員情報参照画面へ
         * ---------------------------------------------- */
        gotoMypageInfo: function () {
            this.$router.push({ path: '/mypage-info' });
        }
    }
};
</script>

<style scoped>
@media screen and (max-width: 575px) {
    .mail-confirm-br {
        display: none;
    }
}
</style>
